import { SET_CONTRACT_INFO, SET_SELECTED_POS } from 'constants/clz';

const defaultState = {
  contractInfo: null,
};

export default (state, payload) => {
  const newState = state || defaultState;
  switch (payload.type) {
    case SET_CONTRACT_INFO: {
      return {
        ...newState,
        contractInfo: payload?.contractInfo,
      };
    }
    case SET_SELECTED_POS: {
      return {
        ...newState,
        selectedPos: payload.selectedPos,
      };
    }
    default:
      return newState;
  }
};
